/**
 * `/$org/apps/contract-intelligence/reviews/$reviewId`: one review — the
 * document with its flagged passages and the results beside it.
 * `?gap=` selects a gap (the address a raised finding links back to). The
 * search type is exported: the generated route tree names it.
 */
import { createFileRoute } from "@tanstack/react-router";

import { CiReviewPage } from "../components/apps/contractIntelligence/CiReviewPage";

export interface ReviewSearch {
  readonly gap?: string;
}

function ReviewRouteView() {
  const { reviewId } = Route.useParams();
  const { gap } = Route.useSearch();
  const navigate = Route.useNavigate();
  return (
    <CiReviewPage
      reviewId={reviewId}
      selectedGapId={gap ?? null}
      onSelectGap={(next) =>
        void navigate({ search: next === null ? {} : { gap: next }, replace: true, resetScroll: false })
      }
    />
  );
}

export const Route = createFileRoute("/$org/apps/contract-intelligence/reviews/$reviewId")({
  validateSearch: (search: Record<string, unknown>): ReviewSearch =>
    typeof search.gap === "string" && search.gap.length > 0 ? { gap: search.gap } : {},
  component: ReviewRouteView,
});
